import React, { useState } from "react";
import logoW from "../../media/images/logo-w.svg";
import { useSelector } from "react-redux";
import Footer from "../../layout/Footer";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import { useDispatch } from "react-redux";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import ForgotPassword from "./ForgotPassword";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";

const LoginPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { darkTheme } = useSelector((state) => state.styles);

  return (
    <div className="login-page">
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>
        <div className="left-login">
          <div className="logo">
            <img
              src={logoW}
              alt="logo"
              onClick={() => {
                window.location.href =
                  process.env.REACT_APP_PRODUCTION_POLICY_URL;
              }}
            />
          </div>
        </div>
        <div className="right-login">
          <div
            className={`sign-up ${pathname === "/signin" ? "login" : ""} flex`}
          >
            <p className="mr-2">
              {pathname === "/signup"
                ? "Already have an account?"
                : "Don't have an account?"}
            </p>
            <ButtonPrimary
              // className="sign-up"
              text={pathname === "/signup" ? "Sign In" : "Sign Up"}
              onClick={() => {
                pathname === "/signup"
                  ? navigate("/signin")
                  : navigate("/signup");
              }}
            />
          </div>

          {pathname === "/signin" && <LoginForm />}

          {pathname === "/signup" && <SignupForm />}
          {pathname === "/forgot-password" && <ForgotPassword />}
        </div>

        {/* <Footer /> */}
      </GoogleOAuthProvider>
    </div>
  );
};

export default LoginPage;
